import { baseURL } from "../../utils/misc";

export const geAllRecordAccessSetups = async (token) => {
  const requestOptions = {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  // Return the fetch Promise
  return await fetch(`${baseURL}/recordaccesssetups`, requestOptions)
    .then((response) => {
      if (!response.ok) {
        return;
      }
      return response.json();
    })
    .then((data) => {
      return data; // Return the data as a resolved value
    })
    .catch((error) => {
      console.error("Error fetching all Record Access Setups Record:", error);
      throw error; // Rethrow the error to propagate it to the caller
    });
};
